import type { PatternPaginatedResponse } from '@/entities/pattern';

import { baseApi, ENDPOINTS } from '@/shared/api';

import type {
    PatternLiveStructureResponse,
    SearchLivePatternsParams,
} from '../model/types/pattern-live';

const patternLiveApi = baseApi
    .enhanceEndpoints({
        addTagTypes: ['PatternLive', 'PatternLiveDistinctFilterValues'],
    })
    .injectEndpoints({
        endpoints: (build) => ({
            getLivePatterns: build.query<
                PatternPaginatedResponse,
                SearchLivePatternsParams
            >({
                query: (params) => ({
                    url: ENDPOINTS.patternLive.getLivePatterns,
                    method: 'GET',
                    params,
                }),
                transformResponse: (response: unknown) => {
                    const typedResponse = response as PatternPaginatedResponse;

                    return {
                        results: typedResponse.results || [],
                        count: typedResponse.count || 0,
                        next: typedResponse.next || null,
                        previous: typedResponse.previous || null,
                    };
                },
            }),
            getLiveDistinctFilterValues: build.query<
                PatternLiveStructureResponse,
                void
            >({
                query: () => ({
                    url: ENDPOINTS.patternLive.getLiveDistinctFilterValues,
                    method: 'GET',
                }),
                providesTags: ['PatternLiveDistinctFilterValues'],
            }),
        }),
    });

export const { useGetLivePatternsQuery, useGetLiveDistinctFilterValuesQuery } =
    patternLiveApi;

export const getLivePatternsFulfilled =
    patternLiveApi.endpoints.getLivePatterns.matchFulfilled;

export const getLiveDistinctFilterValuesFulfilled =
    patternLiveApi.endpoints.getLiveDistinctFilterValues.matchFulfilled;
